// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file marketing_campaign_settings.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file marketing_campaign_settings.proto.
 */
export const file_marketing_campaign_settings: GenFile = /*@__PURE__*/
  fileDesc("CiFtYXJrZXRpbmdfY2FtcGFpZ25fc2V0dGluZ3MucHJvdG8SC2dycGMuYXBpLnYxImcKGU1hcmtldGluZ0NhbXBhaWduU2V0dGluZ3MSGAoQYWxsb3dlZF9tZXNzYWdlcxgCIAEoAxIYChBjcmVhdGVkX21lc3NhZ2VzGAMgASgDEhYKDmR0X3F1b3RhX3Jlc2V0GAQgASgDQgZaBC47cGJiBnByb3RvMw");

/**
 * @generated from message grpc.api.v1.MarketingCampaignSettings
 */
export type MarketingCampaignSettings = Message<"grpc.api.v1.MarketingCampaignSettings"> & {
  /**
   * @generated from field: int64 allowed_messages = 2;
   */
  allowedMessages: bigint;

  /**
   * @generated from field: int64 created_messages = 3;
   */
  createdMessages: bigint;

  /**
   * @generated from field: int64 dt_quota_reset = 4;
   */
  dtQuotaReset: bigint;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignSettings.
 * Use `create(MarketingCampaignSettingsSchema)` to create a new message.
 */
export const MarketingCampaignSettingsSchema: GenMessage<MarketingCampaignSettings> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_settings, 0);

